<template lang="pug">
  div.fill-height
    slot(:open="open")
    ModalWrapper(
      icon="file-download",
      :dialog="dialog",
      :header-text="$t('form.exportAnalysis.header')",
      :max-width="600",
      @close="close",
    )
      template(
        v-if="dialog",
        v-slot:body="",
      )
        v-row
        v-col.pl-0(cols="12")
          DateRangePicker(
            hide-short-cuts,
            format="MMM YYYY",
            type="month",
            :min-date="minDate",
            :placeholder="$t('form.exportAnalysis.date')",
            :value.sync="dates",
          )
        CheckboxPicker(
          col-size="6",
          :title="$t('form.exportAnalysis.shops')",
          :items="shops",
          :value.sync="selectedShops",
        )
      template(v-slot:footer="")
        v-btn(
          :ripple="false",
          color="primary",
          @click="toggleSelections"
        ) {{ selectedShops.length === 0 ? $t("form.exportAnalysis.selectAll") : $t("form.exportAnalysis.clearAll") }}
        v-spacer
        v-btn(
          :ripple="false",
          color="primary",
          @click="close"
        ) {{ $t("form.exportAnalysis.cancel") }}

        v-btn(
          color="primary",
          :disabled="selectedShops.length === 0",
          :ripple="false",
          @click="submit",
        ) {{ $t(`form.exportAnalysis.confirm`) }}
</template>

<script>
import { mapGetters } from 'vuex';
import { pluck, mergeRight } from 'ramda';
import { computeDateRangeDates, getTimezoneOffset } from '@/utils/time';
import { exportCSV } from '@/config/mixins.js';

import CheckboxPicker from '@/components/forms/inputs/CheckboxPicker.vue';
import DateRangePicker from '@/components/forms/inputs/DateRangePicker.vue';
import ModalWrapper from '@/components/wrapper/ModalWrapper.vue';

export default {
  components: {
    CheckboxPicker,
    DateRangePicker,
    ModalWrapper,
  },

  mixins: [exportCSV],

  props: {
    minDate: {
      validator: prop => ['string', 'date'].includes(typeof prop),
      required: true,
    },
  },

  data: () => ({
    dialog: false,
    dates: [],
    selectedShops: [],
  }),

  computed: {
    ...mapGetters({
      shops: 'shop/items',
    }),
  },

  methods: {
    open() {
      this.dialog = true;
      this.selectedShops = [];
      this.dates = [];
    },

    close() {
      this.dialog = false;
    },

    submit() {
      this.dialog = false;
      const params = mergeRight(
        {
          shops: this.selectedShops,
          timezoneOffset: getTimezoneOffset(),
        },
        computeDateRangeDates(this.dates, true),
      );

      this.exportCSV({
        type: 'statistic',
        fileName: 'ScalpAnalysis.csv',
        params,
      });
    },

    toggleSelections() {
      if (this.selectedShops.length === 0) {
        this.selectedShops = pluck('id', this.shops);
      } else {
        this.selectedShops = [];
      }
    },
  },
};
</script>
